import { ConfirmModal } from '@sparklayer-io/spark-dash-ui/components/confirm-modal';
import { t } from 'i18next';
import { useDeleteCustomerGroup } from '../hooks/use-delete-customer-groups';

export function DeleteCustomerGroupModal({
  slug,
  name,
  isOpen,
  closeModal,
}: {
  slug: string;
  name: string;
  isOpen: boolean;
  closeModal: () => void;
}) {
  const { mutate: deleteGroup, isPending } = useDeleteCustomerGroup(name);

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={closeModal}
      onConfirm={() => deleteGroup(slug)}
      loading={isPending}
      title={t(
        'features:customer_group.components.delete_customer_group_modal.confirm_delete.title',
      )}
      confirmText={t('buttons:delete')}
      message={t(
        'features:customer_group.components.delete_customer_group_modal.confirm_delete.body',
        {
          name,
        },
      )}
    />
  );
}
